import { escrowOfficerCard, withApnBesideYearBuilt } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const CAOverrides: ListingLocaleOverrides = {
  locale: 'CA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: withApnBesideYearBuilt,
          fields: {
            assessorParcelNumber: {
              name: 'property.assessorParcelNumber',
              entity: 'property',
              type: 'text',
              label: 'APN Number',
              placeholderText: '',
            },
          },
        },
        mlsInformationCard: {
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.map((prop) => {
                    if (prop.from === 'property.assessorParcelNumber') {
                      return {
                        ...prop,
                        to: 'property.assessorParcelNumber',
                      };
                    }
                    return prop;
                  }),
              },
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        escrow: {
          ...escrowOfficerCard,
          order: -1,
        },
      },
    },
  },
};
